<template>
  <div class="flex items-center justify-center min-h-screen bg-[#F5F0E8]">
    <p class="text-ink/70 text-15">Завершаем вход...</p>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'

onMounted(() => {
  // Telegram Login Widget перенаправляет сюда с hash-параметрами
  const params = new URLSearchParams(window.location.hash.slice(1) || window.location.search)
  const id = params.get('id')

  if (window.opener && id) {
    const userData = {
      id: parseInt(id),
      first_name: params.get('first_name') || '',
      last_name: params.get('last_name') || '',
      username: params.get('username') || '',
      photo_url: params.get('photo_url') || '',
      auth_date: params.get('auth_date') || '',
      hash: params.get('hash') || '',
    }
    window.opener.postMessage({ type: 'telegram-auth', user: userData }, window.location.origin)
    window.close()
  }
})
</script>
